import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';
import SectionHeading from '@/components/base/SectionHeading';

export default function CompletedWorks() {
  const completed = comics.filter((c) => c.isCompleted);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 pb-10 md:px-6 md:pb-14" aria-label="完本佳作">
      <SectionHeading
        title="完本佳作"
        subtitle="一次性看完全部剧情的宝藏作品，放心入坑"
        moreTo="/category/all?status=complete"
        moreLabel="更多完本"
      />
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5">
        {completed.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}